import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { format, addDays } from "date-fns";
import { months } from "../../common-data/DropdowData";
import {
  convertStraight,
  convertThenFormat,
  currentMonthNumber,
  currentYear,
} from "../../common-data/Converts";
import { fetchPTTrainerPerformanceData } from "../../../redux/reducers/apiSlice";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import MealsStructure from "../../diet/meal/MealsStructure";
import CommonFilterStructure from "../../common-components/CommonFilterStructure";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import GTPTTrainerDetails from "./GTPTTrainerDetails";
import OccupencyDetails from "../../components-react/OccupencyDetails";
import { isManagerRole as checkIsManagerRole } from "../../common-data/Conversions";

const PTTrainerPerformance = ({
  userInfoData,
  prevAllFilters = {},
  prevFilters = {},
}) => {
  const dispatch = useDispatch();
  const { ptTrainerPerformanceLoading, ptTrainerPerformance } = useSelector(
    (state) => state.api
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : prevAllFilters?.selectedGym
        ? prevAllFilters.selectedGym
        : "",
    selectedTrainer: "",
    selectedMonth:
      months.find((month) => month.value === currentMonthNumber.toString()) ||
      "",
    selectedYear: {
      label: currentYear,
      value: currentYear,
    },
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    trainer_id: allFilters.selectedTrainer?.value || "",
    month: allFilters.selectedMonth?.value || "",
    year: allFilters.selectedYear?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniPTDatas = {
    pagination: [],
    allTrainers: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const iniModValues = {
    isModOpen1: false,
    modName1: "",
    rowData1: "",
    shiftDetailsQP: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  function getPTTrainerPerformance(filters) {
    dispatch(
      fetchPTTrainerPerformanceData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const onClickValues = (e, row, name) => {
    e.preventDefault();

    const shiftDetailsQP = `gym_id=${row?.gym_id || ""}&trainer_id=${
      row?.trainer_id || ""
    }`;

    const cardName =
      name === "pt-this-month"
        ? "trainer_PT_this_month"
        : name === "active"
        ? "trainer_active_PT_member"
        : name === "expired"
        ? "trainer_expired_PT"
        : name === "expiring"
        ? "trainer_expiring_PT_this_month"
        : name === "pt_business_lost"
        ? "PT_business_lost"
        : name;

    setModValues((prevs) => ({
      ...prevs,
      isModOpen1: true,
      modName1: cardName,
      rowData1: row || "",
      shiftDetailsQP: shiftDetailsQP || "",
    }));
  };

  function onCloseModal() {
    setModValues(iniModValues);
  }

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setAllFilters({
      ...allFilters,
      selectedStartDate: formattedStartDate,
      selectedEndDate: formattedEndDate,
    });
  };

  const clearDateRanger = () => {
    setRangeState(initialRangeState);
    setAllFilters({
      ...allFilters,
      selectedStartDate: "",
      selectedEndDate: "",
    });
  };

  const onClickReset = () => {
    setAllFilters(iniAllFilter);
  };

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedMonth:
        months.find((month) => month.value === currentMonthNumber.toString()) ||
        "",
    }));
  }, []);

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym:
        !isAdmin && !isManagerRole
          ? {
              label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
              value:
                userInfoData?.gym_id ||
                userInfoData?.user_id ||
                userInfoData?.uid ||
                "",
            }
          : prevAllFilters?.selectedGym
          ? prevAllFilters.selectedGym
          : "",
    }));
  }, [prevAllFilters?.selectedGym, userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit,
      gym_id: allFilters.selectedGym?.value || "",
      trainer_id: allFilters.selectedTrainer?.value || "",
      month: allFilters.selectedMonth?.value || "",
      year: allFilters.selectedYear?.value || "",
    }));
  }, [
    allFilters.selectedGym,
    allFilters.selectedTrainer,
    allFilters.selectedMonth,
    allFilters.selectedYear,
    isPage,
    pageLimit,
  ]);

  useEffect(() => {
    getPTTrainerPerformance(filters);
  }, [filters]);

  useEffect(() => {
    if (
      ptTrainerPerformance?.status &&
      ptTrainerPerformance?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allTrainers: ptTrainerPerformance.data,
        pagination:
          ptTrainerPerformance?.pagination?.length > 0
            ? ptTrainerPerformance.pagination
            : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [ptTrainerPerformance]);

  const tbColumns = [
    {
      dataField: "name",
      text: "Trainer Info",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data link"
            onClick={(e) => onClickValues(e, row, "shift_details")}
          >
            {row?.trainer_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.trainer_mobile || ""}
              <br />
              {row?.trainer_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "overall_rankoverall_rank",
      text: "overall rank",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data "
            style={{
              background: "#FEBA0D",
              color: "#1B1A1A",
              borderRadius: "26px",
              padding: "5px 10px",
            }}
          >
            {row?.overall_rank || 0}
          </span>
        );
      },
    },
    {
      dataField: "gym_rank",
      text: "gym rank",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data"
            style={{
              background: "#FEBA0D",
              color: "#1B1A1A",
              borderRadius: "26px",
              padding: "5px 10px",
            }}
          >
            {row?.gym_rank || 0}
          </span>
        );
      },
    },
    {
      dataField: "salary",
      text: "salary",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.salary || 0)}
          </span>
        );
      },
    },
    {
      dataField: "trainer_name",
      text: "Shift Time",
      formatter: (cell, row) => {
        const formatTime = (time) => {
          if (!time) return "";

          const [hours, minutes] = time?.split(":");
          const hour = parseInt(hours, 10);
          const period = hour < 12 ? "AM" : "PM";
          const formattedHour = hour % 12 || 12;
          return `${formattedHour} ${period}`;
        };

        const formattedShifts =
          row?.shift_timing?.length > 0
            ? row?.shift_timing
                .map((shift) => {
                  return `${formatTime(shift?.start_time)} - ${formatTime(
                    shift?.end_time
                  )}`;
                })
                .join("<br>")
            : "-";

        return (
          <span
            className="tb-data minWidth150 underline"
            dangerouslySetInnerHTML={{ __html: formattedShifts || "NA" }}
          ></span>
        );
      },
    },
    {
      dataField: "pt_sold_this_month_amount",
      text: "PT Sold This Month",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth150 link"
            onClick={(e) => onClickValues(e, row, "pt-this-month")}
          >
            ₹{convertThenFormat(row?.pt_sold_this_month_amount || 0)} (
            {row?.pt_sold_this_month || 0})
          </span>
        );
      },
    },
    {
      dataField: "total_active_client",
      text: "Active clients",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data link"
            onClick={(e) => onClickValues(e, row, "active")}
          >
            {row?.total_active_client || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_expiring_this_month",
      text: "PT Expiring This Month",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data link"
            onClick={(e) => onClickValues(e, row, "expiring")}
          >
            {row?.total_expiring_this_month || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_expired_client",
      text: "Expired clients",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data link"
            onClick={(e) => onClickValues(e, row, "expired")}
          >
            {row?.total_expired_client || 0}
          </span>
        );
      },
    },
    {
      dataField: "pt_lifetime_business_amount",
      text: "Lifetime PT Business Done",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth150 link"
            onClick={(e) => onClickValues(e, row, "all")}
          >
            ₹{convertThenFormat(row?.pt_lifetime_business_amount || 0)} (
            {row?.pt_lifetime_business_count || 0})
          </span>
        );
      },
    },
    {
      dataField: "pt_total_lifetime_lost",
      text: "Lifetime PT Business Lost",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth150 link"
            onClick={(e) => onClickValues(e, row, "pt_business_lost")}
          >
            ₹{convertThenFormat(row?.pt_total_lifetime_lost || 0)} (
            {row?.pt_total_lifetime_lost_count || 0})
          </span>
        );
      },
    },
    {
      dataField: "joining_date",
      text: "joining date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.joining_date ? convertStraight(row.joining_date) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <div className="flexCol">
      <Modal
        isOpen={modValues.isModOpen1}
        onRequestClose={() => onCloseModal("mod1")}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          <ModalHeadAndClose
            title={modValues.modName1?.replace(/_/g, " ")}
            onClose={() => onCloseModal("mod1")}
          />

          {modValues.modName1 === "trainer_PT_this_month" ||
          modValues.modName1 === "trainer_active_PT_member" ||
          modValues.modName1 === "trainer_expired_PT" ||
          modValues.modName1 === "trainer_expiring_PT_this_month" ||
          modValues.modName1 === "PT_business_lost" ||
          modValues.modName1 === "all" ? (
            <GTPTTrainerDetails
              prevModValues={modValues}
              userInfoData={userInfoData}
              prevAllFilters={allFilters}
              isPTTrainerPerformance={true}
            />
          ) : modValues.modName1 === "shift_details" ? (
            <OccupencyDetails
              queryParametersForAll={modValues.shiftDetailsQP}
            />
          ) : null}
        </div>
      </Modal>

      <MealsStructure
        text={"All PT Trainer Performance"}
        isReload={() => getPTTrainerPerformance(filters)}
      />

      <CommonFilterStructure
        from={"pt-flow"}
        decryptedText={userInfoData}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickReset={onClickReset}
        clickedCard={"performance_evaluation"}
        handleDateRangeChange={handleDateRangeChange}
        rangeState={rangeState}
        clearDateRanger={clearDateRanger}
        isLoading={ptTrainerPerformanceLoading}
      />

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
        {ptTrainerPerformanceLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={
              Array.isArray(allDatas.allTrainers) &&
              allDatas.allTrainers.length > 0
                ? allDatas.allTrainers
                : []
            }
            tableColumns={tbColumns}
            tablePagination={
              Array.isArray(allDatas.pagination) &&
              allDatas.pagination.length > 0
                ? allDatas.pagination
                : []
            }
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            isFirstColSticky={true}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>
    </div>
  );
};

export default PTTrainerPerformance;
